export const HTTPS = "https://";
export const HTTP = "http://";

//swapi
export const SWAPI_ROOT = "swapi.dev/api/";
export const SWAPI_PEOPLE = "people/";
export const SWAPI_PARAM_PAGE = "?page=";
export const SWAPI_PARAM_SEARCH = "?search="

export const SWAPI_API_PEOPLE = HTTPS + SWAPI_ROOT + SWAPI_PEOPLE + SWAPI_PARAM_PAGE;
export const SWAPI_API_PERSON = HTTPS + SWAPI_ROOT + SWAPI_PEOPLE;
export const SWAPI_API_SEARCH = HTTPS + SWAPI_ROOT + SWAPI_PEOPLE + SWAPI_PARAM_SEARCH;


// visualguide
const GUIDE_ROOT_IMG = 'https://starwars-visualguide.com/assets/img/';
const GUIDE_CHARACTERS = 'characters';
export const GUIDE_IMG_EXTENSION = '.jpg';
export const GUIDE_URL_IMG_PEOPLE = GUIDE_ROOT_IMG + GUIDE_CHARACTERS;